<template>
    <div id="regions-pie-chart">

    </div>
</template>

<script>
import Highcharts from 'highcharts';

export default {
    name: 'RegionsPieChart',
    props: {
        statistiques: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            series: []
        }
    },
    mounted() {
        this.buildSeries();
        this.buildChart();
    },
    methods: {
        buildSeries() {
            const total = this.getTotal();
            for (let region in this.statistiques) {
                let name = region;
                if (name.includes('inter_')) {
                    name = this.getCountryName(name);
                }
                let percent = this.statistiques[region] / total * 100;
                percent = Number(percent.toFixed(2));

                this.series.push({
                    name: name + ' (' + this.statistiques[region] + ')',
                    y: percent
                });
            }

            // Trier la série du maximum au minimum
            this.series.sort((a, b) => b.y - a.y);


        },
        getTotal() {
            let total = 0;
            for (let region in this.statistiques) {
                total += this.statistiques[region];
            }
            return total;
        },
        getCountryName(name) {
            let country_code = name.replace('inter_', '');
            const list_country = this.$itemsSelect.pays();
            for (let country of list_country) {
                if (country.value == country_code) {
                    return country.title;
                }
            }
            return country_code;
        },
        buildChart() {
            Highcharts.chart('regions-pie-chart', {
                chart: {
                    type: 'bar',
                    height: this.series.length * 35 + 100, // Hauteur dynamique basée sur le nombre d'éléments
                    zooming: {
                        type: 'xy'
                    },
                    panning: {
                        enabled: true,
                        type: 'xy'
                    },
                    panKey: 'shift',

                },
                title: {
                    text: 'Répartition par région'
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                    min: 0,
                    max: this.series.length - 1, // Afficher toutes les catégories
                    scrollbar: {
                        enabled: false
                    }
                },
                yAxis: {
                    title: {
                        text: 'Pourcentage (%)'
                    },
                    labels: {
                        format: '{value}%'
                    }
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>{point.y:.1f}%</b>'
                },
                plotOptions: {
                    bar: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '{point.y:.1f}%',
                            style: {
                                fontSize: '12px',
                                fontWeight: 'bold',
                                textOutline: '1px contrast'
                            }
                        },
                        showInLegend: false
                    }
                },
                series: [
                    {
                        name: 'Pourcentage',
                        colorByPoint: true,
                        data: this.series
                    }
                ]
            });
        }
    }
}

</script>

<style lang="scss" scoped></style>